<script>
  import { Title, Content } from '@smui/paper';
  import Button, { Label, Icon } from '@smui/button';
  import { createEventDispatcher } from 'svelte';
  import { audio as mainAudio, states } from '$lib/audio-store';
  export let ask;
  export let preload = "auto";
  let audioElement;
const track = ask.context;
  const dispatch = createEventDispatcher();
</script>

<Title>{ask.title ? ask.title : `You've got a message from ${track.artist.name}`}</Title>
<Content>
  <p>{ask.content}</p>

  <nav class="actions b--secondary b--solid-t-tiny u-mt u-pt">
    <slot name="actions" />
    {#if ask.presigned_url}
      <audio
        src={ask.presigned_url}
        on:ended={async () => {
          dispatch('completed');
          if ($mainAudio.state === states.PAUSED) await mainAudio.play();
        }}
        {preload}
        bind:this={audioElement}
      >
        <p>Download the message <a href={ask.presigned_url} class="link">here</a></p>
      </audio>

      <Button
        color="primary"
        variant="raised"
        on:click={async () => {
          if ($mainAudio.state === states.PLAYING) await mainAudio.pause();
          await audioElement.play();
        }}
      >
        <Label>Listen</Label>
        <Icon class="material-icons">play_circle</Icon></Button
      >
    {:else}
      <Button
        class="complete-ask"
        color="primary"
        variant="raised"
        on:click={() => dispatch('completed')}
      >
        <Label>OK</Label>
        <Icon class="material-icons">navigate_next</Icon></Button
      >
    {/if}
  </nav>
</Content>
